import { render, staticRenderFns } from "./issue_status_icon.vue?vue&type=template&id=3d10e10c"
import script from "./issue_status_icon.vue?vue&type=script&lang=js"
export * from "./issue_status_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports